<div class="sb-step sb-step-document">
  <form class="sb-step__form" [formGroup]="formGroup">
    <div class="sb-step__form__content">
      <div class="sb-step__inner-container">
        <!-- <sb-promo-banner></sb-promo-banner> -->
        <div class="sb-form-block">
          <div class="sb-form-block__title">
            {{'ENTITY.CUSTOMER-DOCUMENT.TITLE' | translate}}
          </div>
          <div class="sb-form-block__fields" formGroupName="customerDocument">
            <div class="row wt-margin-bottom-4">
              <div class="col-tb-4 col-xs-12">
                <wt-input-select [label]="'ENTITY.CUSTOMER-DOCUMENT.TYPE' | translate" [placeholder]="'ENTITY.CUSTOMER-DOCUMENT.TYPE' | translate" [items]="documentTypes" formControlName="type"></wt-input-select>
              </div>
              <div class="col-tb-4 col-xs-12">
                <div class="sb-form-block__field">
                  <wt-input-text [validateOnBlur]="true" [maxLength]="FormConstants.MAXIMUM_DOCUMENT_VALUE_LENGTH" [label]="'ENTITY.CUSTOMER-DOCUMENT.VALUE' | translate" additionalClass="sb-transform-uppercase" formControlName="number"></wt-input-text>
                </div>
              </div>
              <div class="col-tb-4 col-xs-12">
                <div class="sb-form-block__field">
                  <wt-input-date [validateOnBlur]="true" [label]="'ENTITY.CUSTOMER-DOCUMENT.RELEASE-DATE' | translate" [placeholder]="'ENTITY.CUSTOMER-DOCUMENT.RELEASE-DATE.PLACEHOLDER' | translate" formControlName="issueDate"></wt-input-date>
                </div>
              </div>
            </div>
            <sb-box-info [iconType]="['icon-document']" [infoText]="(isESim ? 'ENTITY.CUSTOMER-DOCUMENT.INFO_ESIM' : 'ENTITY.CUSTOMER-DOCUMENT.INFO') | translate"></sb-box-info>
          </div>
        </div>
      </div>
    </div>
    <div class="sb-step__form__footer">
      <sb-navigation-buttons [isSticky]="shouldBeSticky" [submitDisabled]="this.formGroup.invalid" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
    </div>
  </form>
</div>
